import { Spreadsheet, getRangeAddress } from '@syncfusion/ej2-spreadsheet';
import { Uploader } from '@syncfusion/ej2-inputs';
import { ExcelWorksheetCellModel, ExcelWorksheetModel, SetWorkbookDataModel } from '../../Models/Excel/SetWorkbookDataModel';
import { ExcelDataService } from '../../DataService/ExcelDataService';

import { Grid, Filter, Page, Sort, RecordClickEventArgs, Toolbar } from '@syncfusion/ej2-grids';
import { Query, DataManager, WebApiAdaptor } from '@syncfusion/ej2-data';
import { closest, L10n } from '@syncfusion/ej2-base';
import { ModalHelper } from '../../Helpers/ModalHelper';
import { Toastr } from '../../Helpers/Toastr';
import { SyncfusionGridHelper } from '../../Helpers/SyncfusionGridHelper';

export class ImpaTableManager {

    constructor(private containerElement: JQuery) { }

    private fileUploadInput : JQuery<HTMLElement>;
    //private workbookContentWrapper : JQuery<HTMLElement>;
    //private viewWorkbookModalHelper : ModalHelper;

    private workbookGrid : Grid;
    

    public initialize() {
        var self = this;

        self.fileUploadInput = self.containerElement.find('#impa-file-upload-input');

        Grid.Inject(Toolbar, Filter, Page, Sort);

        self.initializeUploadAndWorkbooksTable();
    }

    private initializeUploadAndWorkbooksTable() {
        var self = this;

        var loadingContainer = self.containerElement.find('#loading-container');
        var uploadContainer = self.containerElement.find('#impa-upload-and-items-container');
        var gridElement : JQuery<HTMLElement> = self.containerElement.find('#CommonTableArticlesGrid');
        var gridContentElement : JQuery<HTMLElement> = gridElement;

        var uploadObject : Uploader;
        

        var uploadedDocumentId = '';

        var spreadsheetElement = self.containerElement.find('#element');

        L10n.load({
            "impa-en-US": {
                "uploader": { 
                    "dropFilesHint" : "Drop the official IMPA.xlsx file here"
                }
            }
        })

        uploadObject = new Uploader({
            maxFileSize: 40000000,
            autoUpload: false,
            asyncSettings: {
                saveUrl: '/api/company/commontables/uploadimpaxlsx',
                removeUrl: '/api/company/commontables/removefile'
            },
            multiple: false,
            allowedExtensions: '.xlsx',
            locale: 'impa-en-US',
            created: () => {
                loadingContainer.addClass('d-none');
                uploadContainer.removeClass('d-none');
            },
            beforeUpload: () => {
                spreadsheetElement.addClass('d-none');
                //spreadsheet.destroy();
            },
            uploading: () => {
                //self.workbookContentWrapper.css('height', '78dvh');
            },
            success: (args: any) => {                    
                if (args.operation == 'upload') {
                    uploadedDocumentId = args.e.target.response;
                    //spreadsheet.open({ file: args.file.rawFile });
                }
            },
        });

        
        var fileInput = self.fileUploadInput.get(0);
        // render initialized Uploader
        uploadObject.appendTo(fileInput);

        self.fileUploadInput.removeClass('d-none');

        let data: DataManager = new DataManager({
            url: '/api/company/lookup/impa',
            adaptor: new WebApiAdaptor
        });

        self.workbookGrid = new Grid(
            {
                height: '100%',
                dataSource: data,
                toolbarTemplate: '#toolbar-template',
                columns: [
                    { field: 'Catalog', headerText: 'Catalog', autoFit: true, width: 100 },
                    { field: 'Code', headerText: 'Code', autoFit: true, width: 100 },
                    { field: 'Level1', headerText: 'Lvl 1', width: 125, allowFiltering: false},
                    { field: 'Level2', headerText: 'Lvl 2', width: 125, allowFiltering: false},
                    { field: 'Level3', headerText: 'Lvl 3', width: 125, allowFiltering: false},
                    { field: 'Description', headerText: 'Description'},
                    { field: 'UoM', headerText: 'UoM', width: 150, allowFiltering: false},
                ],
                allowSorting: true,
                allowPaging: true,
                allowFiltering: true,
                allowSelection: false,
                enablePersistence: true,
                pageSettings: { pageSize: 100 },
                created: () => {
                    gridContentElement = gridContentElement.find('.e-content')
                },
                actionBegin: (args) => {
                    if (!this.workbookGrid) {
                        return;
                    }

                    if (SyncfusionGridHelper.isFilterAction(args)) {
                        this.workbookGrid.pageSettings.currentPage = 1;
                    }
                }
            });
        self.workbookGrid.appendTo('#CommonTableArticlesGrid');

        var toolbar = this.containerElement.find('#toolbar-template');
        if(toolbar != undefined && toolbar.length > 0) {
            var clearFiltersButton = toolbar.find('#clear-filters-button');
            clearFiltersButton.off('click').on('click', () => {
                self.workbookGrid.pageSettings.currentPage = 1;
                self.workbookGrid.clearFiltering();
                self.workbookGrid.refreshHeader();
            })
        }
    }

}